import React from 'react';
import { InputContainer } from '../../../../../../common/components/form/form.module';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';

export const ServiceabilityBasicInfoComponent = ({ accountsList, accountListLoading, accountTypesList, accountTypesListLoading, PolicyOwnerType, onInnerBasicFormChange, selectedServiceabilitys, vendors }: any) => (

  <><AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
        <InputContainer

          label="Active"
          name="IsActive"
          onValueChange={(event: any) => {
            onInnerBasicFormChange(
              event,
              'IsActive'

            )
          }}
          type="checkbox"
          value={selectedServiceabilitys?.IsActive}
        />

        <InputContainer

          label="Name"
          name="Name"
          onValueChange={(event: any) => {
            onInnerBasicFormChange(
              event.target.value,
              'Name'

            )
          }}
          type="text"
          value={selectedServiceabilitys?.Name}
        />

        <InputContainer

          label="DisplayOrder"
          name="DisplayOrder"
          onValueChange={(event: any) => {
            onInnerBasicFormChange(
              event.target.value,
              'DisplayOrder'

            )
          }}
          type="number"
          value={selectedServiceabilitys?.DisplayOrder}
        />


        <InputContainer
          label="Level"
          labelField="Text"
          list={PolicyOwnerType}
          isDisabled={selectedServiceabilitys?.Id && selectedServiceabilitys?.OwnerLevelId}
          onValueChange={(event: any) => {
            onInnerBasicFormChange(
              event.target.value,
              'OwnerLevelId'
            );
          }}
          optionName='Choose Level'
          type="select"
          value={selectedServiceabilitys?.OwnerLevelId}
          valueField="Value"
        />
        <InputContainer
          label="Account Type"
          labelField="Name"
          isLoading={accountTypesListLoading}
          list={accountTypesList}
          isDisabled={selectedServiceabilitys?.Id && selectedServiceabilitys?.OwnerTypeId}
          onValueChange={(event: any, newValue: any) => {
            onInnerBasicFormChange(
              event.target.value,
              'OwnerTypeId',
            );
          }}
          optionName='Choose Account Type'
          type="select"
          value={selectedServiceabilitys?.OwnerTypeId}
          valueField="Id"
        />
        <InputContainer
          label="Account Name"
          labelField="Name"
          isLoading={accountListLoading}
          list={accountsList}
          isDisabled={selectedServiceabilitys?.Id && selectedServiceabilitys?.OwnerAccountId}
          onValueChange={(event: any, newValue: any) => {
            onInnerBasicFormChange(
              event.target.value,
              'OwnerAccountId',
            );
          }}
          optionName='Choose Account Name'
          type="select"
          value={selectedServiceabilitys?.OwnerAccountId}
          valueField="Id"
        />

        <InputContainer

          label="Always Enabled"
          name="IsAlwaysEnabled"
          onValueChange={(event: any) => {
            onInnerBasicFormChange(
              event,
              'IsAlwaysEnabled'

            )
          }}
          type="checkbox"
          value={selectedServiceabilitys?.IsAlwaysEnabled}
        />
        {!selectedServiceabilitys?.IsAlwaysEnabled && (
          <InputContainer

            label="StartDate"
            name="StartDateUtc"
            onValueChange={(event: any) => {
              onInnerBasicFormChange(
                event.target.value,
                'StartDateUtc'
              )
            }}
            type="date"
            value={selectedServiceabilitys?.StartDateUtc}
          />
        )}
        {!selectedServiceabilitys?.IsAlwaysEnabled && (
          <InputContainer

            label="EndDate"
            name="EndDateUtc"
            onValueChange={(event: any) => {
              onInnerBasicFormChange(
                event.target.value,
                'EndDateUtc'
              )
            }}
            type="date"
            value={selectedServiceabilitys?.EndDateUtc}
          />
        )}


        <InputContainer

          label="Remarks"
          name="Remarks"
          onValueChange={(event: any) => {
            onInnerBasicFormChange(
              event.target.value,
              'Remarks'

            )
          }}
          type="text"
          value={selectedServiceabilitys?.Remarks}
        />
        <div className='col-span-full'>
          <InputContainer

            label="Description"
            name="Description"
            onValueChange={(event: any) => {
              onInnerBasicFormChange(
                event,
                'Description'

              )
            }}
            type="rte"
            value={selectedServiceabilitys?.Description}
          />
        </div>


      </div>
    }
    expandedPanel="Basic Info"
    headerTitle="Basic Info"
  />
  </>

)
export default ServiceabilityBasicInfoComponent;
